import {
    ADD_SUGGESTED_DAMAGE_IMAGE,
    DELETE_DAMAGE,
    DELETE_DAMAGE_IMAGE,
    SET_DAMAGE_IMAGES,
    UNLOAD_WORK_ORDER,
    UPDATE_DAMAGE_IMAGE
} from "../actions/dispatchTypes";
import {DELETED, UPDATED, USE_EXISTING} from "../utils/constants";

export default function damageImageReducer(state = null, action) {

    switch (action.type) {
        case UNLOAD_WORK_ORDER:
            return null;
        case SET_DAMAGE_IMAGES:
            return action.damageImages;
        case DELETE_DAMAGE_IMAGE:
            return deleteDamageImage(state, action.payload.key);
        case UPDATE_DAMAGE_IMAGE:
            return addOrUpdateDamageImage(state, action, UPDATED);
        case DELETE_DAMAGE:
            return deleteDamageImage(state, action.payload.damageId);
        case ADD_SUGGESTED_DAMAGE_IMAGE:
            const status = action.payload.imageAction === UPDATED ? UPDATED : USE_EXISTING;
            return addOrUpdateDamageImage(state, action, status);
        default:
            return state;
    }
}

function deleteDamageImage(state, key) {
    return Object.assign([], state.map(damageImage => {
        if (damageImage.key === key) {
            damageImage.status = DELETED;
        }
        return damageImage;
    }));
}

function addOrUpdateDamageImage(state, action, status) {
    if (state.filter(damageImage => damageImage.key === action.payload.key).length) {
        return Object.assign([], state.map(damageImage => {
            if (damageImage.key === action.payload.key) {
                damageImage.url = action.payload.url;
                damageImage.status = status
            }
            return damageImage;
        }));
    } else {
        return state.concat([{key: action.payload.key, status: status, url: action.payload.url}]);
    }
}
